export default {
  no_mobile_app: 'Aucune application mobile configurée',
  mobile_app_not_live: 'Application mobile non active',
};
